/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  FleetCalendar,
  FleetCalendarParams,
  FleetEventCreateInput,
  FleetEventExtended,
  FleetEventOccurrenceDateInput,
  FleetEventOccurrenceState,
  FleetEventOccurrenceUpdateInput,
  FleetEventParams,
  FleetEventUpdateInput,
  FleetEventsList,
  FleetEventsParams,
  SchemaValidationErrorResponse,
  StandardError
} from '../../models';

import { axiosClient } from '../../../axiosClient.ts';
import type { ErrorType } from '../../../axiosClient.ts';




/**
 * @summary Fleet Calendar
 */
export const fleetCalendar = (
    fleetSlug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<FleetCalendarParams>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
params = toValue(params);

      return axiosClient<FleetCalendar>(
      {url: `/fleets/${fleetSlug}/calendar`, method: 'GET',
        params, signal
    },
      );
    }




export const getFleetCalendarQueryKey = (fleetSlug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<FleetCalendarParams>,) => {
    return [
    'fleets',fleetSlug,'calendar', ...(params ? [params] : [])
    ] as const;
    }


export const getFleetCalendarQueryOptions = <TData = Awaited<ReturnType<typeof fleetCalendar>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(fleetSlug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<FleetCalendarParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetCalendar>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getFleetCalendarQueryKey(fleetSlug,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof fleetCalendar>>> = ({ signal }) => fleetCalendar(fleetSlug,params, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(fleetSlug) !== null && toValue(fleetSlug) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fleetCalendar>>, TError, TData>
}

export type FleetCalendarQueryResult = NonNullable<Awaited<ReturnType<typeof fleetCalendar>>>
export type FleetCalendarQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Fleet Calendar
 */

export function useFleetCalendar<TData = Awaited<ReturnType<typeof fleetCalendar>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 fleetSlug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<FleetCalendarParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetCalendar>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFleetCalendarQueryOptions(fleetSlug,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Create Fleet Event
 */
export const createFleetEvent = (
    fleetSlug: MaybeRefOrGetter<string>,
    fleetEventCreateInput: MaybeRefOrGetter<FleetEventCreateInput>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
fleetEventCreateInput = toValue(fleetEventCreateInput);

      return axiosClient<FleetEventExtended>(
      {url: `/fleets/${fleetSlug}/events`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: fleetEventCreateInput, signal
    },
      );
    }




export const getCreateFleetEventMutationKey = () => ['createFleetEvent'] as const;

export const getCreateFleetEventMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFleetEvent>>, TError,CreateFleetEventMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createFleetEvent>>, TError,CreateFleetEventMutationVariables, TContext> => {

const mutationKey = getCreateFleetEventMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createFleetEvent>>, CreateFleetEventMutationVariables> = (props) => {
          const {fleetSlug,data} = props ?? {};

          return  createFleetEvent(fleetSlug,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateFleetEventMutationResult = NonNullable<Awaited<ReturnType<typeof createFleetEvent>>>
    export type CreateFleetEventMutationBody = FleetEventCreateInput
    export type CreateFleetEventMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type CreateFleetEventMutationVariables = {fleetSlug: string;data: FleetEventCreateInput}

    /**
 * @summary Create Fleet Event
 */
export const useCreateFleetEvent = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createFleetEvent>>, TError,CreateFleetEventMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createFleetEvent>>,
        TError,
        CreateFleetEventMutationVariables,
        TContext
      > => {
      return useMutation(getCreateFleetEventMutationOptions(options), queryClient);
    }
    /**
 * @summary List Fleet Events
 */
export const fleetEvents = (
    fleetSlug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<FleetEventsParams>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
params = toValue(params);

      return axiosClient<FleetEventsList>(
      {url: `/fleets/${fleetSlug}/events`, method: 'GET',
        params, signal
    },
      );
    }




export const getFleetEventsQueryKey = (fleetSlug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<FleetEventsParams>,) => {
    return [
    'fleets',fleetSlug,'events', ...(params ? [params] : [])
    ] as const;
    }


export const getFleetEventsQueryOptions = <TData = Awaited<ReturnType<typeof fleetEvents>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(fleetSlug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<FleetEventsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetEvents>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getFleetEventsQueryKey(fleetSlug,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof fleetEvents>>> = ({ signal }) => fleetEvents(fleetSlug,params, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(fleetSlug) !== null && toValue(fleetSlug) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fleetEvents>>, TError, TData>
}

export type FleetEventsQueryResult = NonNullable<Awaited<ReturnType<typeof fleetEvents>>>
export type FleetEventsQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary List Fleet Events
 */

export function useFleetEvents<TData = Awaited<ReturnType<typeof fleetEvents>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 fleetSlug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<FleetEventsParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetEvents>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFleetEventsQueryOptions(fleetSlug,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Archive Fleet Event
 */
export const destroyFleetEvent = (
    fleetSlug: MaybeRefOrGetter<string>,
    slug: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
slug = toValue(slug);

      return axiosClient<FleetEventExtended | void>(
      {url: `/fleets/${fleetSlug}/events/${slug}`, method: 'DELETE', signal
    },
      );
    }




export const getDestroyFleetEventMutationKey = () => ['destroyFleetEvent'] as const;

export const getDestroyFleetEventMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyFleetEvent>>, TError,DestroyFleetEventMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof destroyFleetEvent>>, TError,DestroyFleetEventMutationVariables, TContext> => {

const mutationKey = getDestroyFleetEventMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof destroyFleetEvent>>, DestroyFleetEventMutationVariables> = (props) => {
          const {fleetSlug,slug} = props ?? {};

          return  destroyFleetEvent(fleetSlug,slug,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DestroyFleetEventMutationResult = NonNullable<Awaited<ReturnType<typeof destroyFleetEvent>>>

    export type DestroyFleetEventMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type DestroyFleetEventMutationVariables = {fleetSlug: string;slug: string}

    /**
 * @summary Archive Fleet Event
 */
export const useDestroyFleetEvent = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyFleetEvent>>, TError,DestroyFleetEventMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof destroyFleetEvent>>,
        TError,
        DestroyFleetEventMutationVariables,
        TContext
      > => {
      return useMutation(getDestroyFleetEventMutationOptions(options), queryClient);
    }
    /**
 * @summary Show Fleet Event
 */
export const fleetEvent = (
    fleetSlug: MaybeRefOrGetter<string>,
    slug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<FleetEventParams>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
slug = toValue(slug);
params = toValue(params);

      return axiosClient<FleetEventExtended>(
      {url: `/fleets/${fleetSlug}/events/${slug}`, method: 'GET',
        params, signal
    },
      );
    }




export const getFleetEventQueryKey = (fleetSlug: MaybeRefOrGetter<string>,
    slug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<FleetEventParams>,) => {
    return [
    'fleets',fleetSlug,'events',slug, ...(params ? [params] : [])
    ] as const;
    }


export const getFleetEventQueryOptions = <TData = Awaited<ReturnType<typeof fleetEvent>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(fleetSlug: MaybeRefOrGetter<string>,
    slug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<FleetEventParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetEvent>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getFleetEventQueryKey(fleetSlug,slug,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof fleetEvent>>> = ({ signal }) => fleetEvent(fleetSlug,slug,params, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(fleetSlug) !== null && toValue(fleetSlug) !== undefined && toValue(slug) !== null && toValue(slug) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof fleetEvent>>, TError, TData>
}

export type FleetEventQueryResult = NonNullable<Awaited<ReturnType<typeof fleetEvent>>>
export type FleetEventQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Show Fleet Event
 */

export function useFleetEvent<TData = Awaited<ReturnType<typeof fleetEvent>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 fleetSlug: MaybeRefOrGetter<string>,
    slug: MaybeRefOrGetter<string>,
    params?: MaybeRefOrGetter<FleetEventParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof fleetEvent>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getFleetEventQueryOptions(fleetSlug,slug,params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Update Fleet Event
 */
export const updateFleetEvent = (
    fleetSlug: MaybeRefOrGetter<string>,
    slug: MaybeRefOrGetter<string>,
    fleetEventUpdateInput: MaybeRefOrGetter<FleetEventUpdateInput>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
slug = toValue(slug);
fleetEventUpdateInput = toValue(fleetEventUpdateInput);

      return axiosClient<FleetEventExtended>(
      {url: `/fleets/${fleetSlug}/events/${slug}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: fleetEventUpdateInput, signal
    },
      );
    }




export const getUpdateFleetEventMutationKey = () => ['updateFleetEvent'] as const;

export const getUpdateFleetEventMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateFleetEvent>>, TError,UpdateFleetEventMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateFleetEvent>>, TError,UpdateFleetEventMutationVariables, TContext> => {

const mutationKey = getUpdateFleetEventMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateFleetEvent>>, UpdateFleetEventMutationVariables> = (props) => {
          const {fleetSlug,slug,data} = props ?? {};

          return  updateFleetEvent(fleetSlug,slug,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateFleetEventMutationResult = NonNullable<Awaited<ReturnType<typeof updateFleetEvent>>>
    export type UpdateFleetEventMutationBody = FleetEventUpdateInput
    export type UpdateFleetEventMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type UpdateFleetEventMutationVariables = {fleetSlug: string;slug: string;data: FleetEventUpdateInput}

    /**
 * @summary Update Fleet Event
 */
export const useUpdateFleetEvent = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateFleetEvent>>, TError,UpdateFleetEventMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateFleetEvent>>,
        TError,
        UpdateFleetEventMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateFleetEventMutationOptions(options), queryClient);
    }
    /**
 * @summary Cancel Fleet Event
 */
export const cancelFleetEvent = (
    fleetSlug: MaybeRefOrGetter<string>,
    slug: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
slug = toValue(slug);

      return axiosClient<FleetEventExtended>(
      {url: `/fleets/${fleetSlug}/events/${slug}/cancel`, method: 'PUT', signal
    },
      );
    }




export const getCancelFleetEventMutationKey = () => ['cancelFleetEvent'] as const;

export const getCancelFleetEventMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelFleetEvent>>, TError,CancelFleetEventMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof cancelFleetEvent>>, TError,CancelFleetEventMutationVariables, TContext> => {

const mutationKey = getCancelFleetEventMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancelFleetEvent>>, CancelFleetEventMutationVariables> = (props) => {
          const {fleetSlug,slug} = props ?? {};

          return  cancelFleetEvent(fleetSlug,slug,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CancelFleetEventMutationResult = NonNullable<Awaited<ReturnType<typeof cancelFleetEvent>>>

    export type CancelFleetEventMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type CancelFleetEventMutationVariables = {fleetSlug: string;slug: string}

    /**
 * @summary Cancel Fleet Event
 */
export const useCancelFleetEvent = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelFleetEvent>>, TError,CancelFleetEventMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof cancelFleetEvent>>,
        TError,
        CancelFleetEventMutationVariables,
        TContext
      > => {
      return useMutation(getCancelFleetEventMutationOptions(options), queryClient);
    }
    /**
 * @summary Complete Fleet Event
 */
export const completeFleetEvent = (
    fleetSlug: MaybeRefOrGetter<string>,
    slug: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
slug = toValue(slug);

      return axiosClient<FleetEventExtended>(
      {url: `/fleets/${fleetSlug}/events/${slug}/complete`, method: 'PUT', signal
    },
      );
    }




export const getCompleteFleetEventMutationKey = () => ['completeFleetEvent'] as const;

export const getCompleteFleetEventMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof completeFleetEvent>>, TError,CompleteFleetEventMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof completeFleetEvent>>, TError,CompleteFleetEventMutationVariables, TContext> => {

const mutationKey = getCompleteFleetEventMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof completeFleetEvent>>, CompleteFleetEventMutationVariables> = (props) => {
          const {fleetSlug,slug} = props ?? {};

          return  completeFleetEvent(fleetSlug,slug,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CompleteFleetEventMutationResult = NonNullable<Awaited<ReturnType<typeof completeFleetEvent>>>

    export type CompleteFleetEventMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type CompleteFleetEventMutationVariables = {fleetSlug: string;slug: string}

    /**
 * @summary Complete Fleet Event
 */
export const useCompleteFleetEvent = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof completeFleetEvent>>, TError,CompleteFleetEventMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof completeFleetEvent>>,
        TError,
        CompleteFleetEventMutationVariables,
        TContext
      > => {
      return useMutation(getCompleteFleetEventMutationOptions(options), queryClient);
    }
    /**
 * @summary End a recurring event series from a given date
 */
export const endFleetEventSeries = (
    fleetSlug: MaybeRefOrGetter<string>,
    slug: MaybeRefOrGetter<string>,
    fleetEventOccurrenceDateInput: MaybeRefOrGetter<FleetEventOccurrenceDateInput>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
slug = toValue(slug);
fleetEventOccurrenceDateInput = toValue(fleetEventOccurrenceDateInput);

      return axiosClient<FleetEventExtended>(
      {url: `/fleets/${fleetSlug}/events/${slug}/end-series`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: fleetEventOccurrenceDateInput, signal
    },
      );
    }




export const getEndFleetEventSeriesMutationKey = () => ['endFleetEventSeries'] as const;

export const getEndFleetEventSeriesMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof endFleetEventSeries>>, TError,EndFleetEventSeriesMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof endFleetEventSeries>>, TError,EndFleetEventSeriesMutationVariables, TContext> => {

const mutationKey = getEndFleetEventSeriesMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof endFleetEventSeries>>, EndFleetEventSeriesMutationVariables> = (props) => {
          const {fleetSlug,slug,data} = props ?? {};

          return  endFleetEventSeries(fleetSlug,slug,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type EndFleetEventSeriesMutationResult = NonNullable<Awaited<ReturnType<typeof endFleetEventSeries>>>
    export type EndFleetEventSeriesMutationBody = FleetEventOccurrenceDateInput
    export type EndFleetEventSeriesMutationError = ErrorType<SchemaValidationErrorResponse>
    export type EndFleetEventSeriesMutationVariables = {fleetSlug: string;slug: string;data: FleetEventOccurrenceDateInput}

    /**
 * @summary End a recurring event series from a given date
 */
export const useEndFleetEventSeries = <TError = ErrorType<SchemaValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof endFleetEventSeries>>, TError,EndFleetEventSeriesMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof endFleetEventSeries>>,
        TError,
        EndFleetEventSeriesMutationVariables,
        TContext
      > => {
      return useMutation(getEndFleetEventSeriesMutationOptions(options), queryClient);
    }
    /**
 * @summary Lock Signups
 */
export const lockFleetEventSignups = (
    fleetSlug: MaybeRefOrGetter<string>,
    slug: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
slug = toValue(slug);

      return axiosClient<FleetEventExtended>(
      {url: `/fleets/${fleetSlug}/events/${slug}/lock-signups`, method: 'PUT', signal
    },
      );
    }




export const getLockFleetEventSignupsMutationKey = () => ['lockFleetEventSignups'] as const;

export const getLockFleetEventSignupsMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof lockFleetEventSignups>>, TError,LockFleetEventSignupsMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof lockFleetEventSignups>>, TError,LockFleetEventSignupsMutationVariables, TContext> => {

const mutationKey = getLockFleetEventSignupsMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof lockFleetEventSignups>>, LockFleetEventSignupsMutationVariables> = (props) => {
          const {fleetSlug,slug} = props ?? {};

          return  lockFleetEventSignups(fleetSlug,slug,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LockFleetEventSignupsMutationResult = NonNullable<Awaited<ReturnType<typeof lockFleetEventSignups>>>

    export type LockFleetEventSignupsMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type LockFleetEventSignupsMutationVariables = {fleetSlug: string;slug: string}

    /**
 * @summary Lock Signups
 */
export const useLockFleetEventSignups = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof lockFleetEventSignups>>, TError,LockFleetEventSignupsMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof lockFleetEventSignups>>,
        TError,
        LockFleetEventSignupsMutationVariables,
        TContext
      > => {
      return useMutation(getLockFleetEventSignupsMutationOptions(options), queryClient);
    }
    /**
 * @summary Publish Fleet Event
 */
export const publishFleetEvent = (
    fleetSlug: MaybeRefOrGetter<string>,
    slug: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
slug = toValue(slug);

      return axiosClient<FleetEventExtended>(
      {url: `/fleets/${fleetSlug}/events/${slug}/publish`, method: 'PUT', signal
    },
      );
    }




export const getPublishFleetEventMutationKey = () => ['publishFleetEvent'] as const;

export const getPublishFleetEventMutationOptions = <TError = ErrorType<StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof publishFleetEvent>>, TError,PublishFleetEventMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof publishFleetEvent>>, TError,PublishFleetEventMutationVariables, TContext> => {

const mutationKey = getPublishFleetEventMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof publishFleetEvent>>, PublishFleetEventMutationVariables> = (props) => {
          const {fleetSlug,slug} = props ?? {};

          return  publishFleetEvent(fleetSlug,slug,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PublishFleetEventMutationResult = NonNullable<Awaited<ReturnType<typeof publishFleetEvent>>>

    export type PublishFleetEventMutationError = ErrorType<StandardError>
    export type PublishFleetEventMutationVariables = {fleetSlug: string;slug: string}

    /**
 * @summary Publish Fleet Event
 */
export const usePublishFleetEvent = <TError = ErrorType<StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof publishFleetEvent>>, TError,PublishFleetEventMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof publishFleetEvent>>,
        TError,
        PublishFleetEventMutationVariables,
        TContext
      > => {
      return useMutation(getPublishFleetEventMutationOptions(options), queryClient);
    }
    /**
 * @summary Skip a specific occurrence of a recurring event
 */
export const skipFleetEventOccurrence = (
    fleetSlug: MaybeRefOrGetter<string>,
    slug: MaybeRefOrGetter<string>,
    fleetEventOccurrenceDateInput: MaybeRefOrGetter<FleetEventOccurrenceDateInput>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
slug = toValue(slug);
fleetEventOccurrenceDateInput = toValue(fleetEventOccurrenceDateInput);

      return axiosClient<FleetEventExtended>(
      {url: `/fleets/${fleetSlug}/events/${slug}/skip-occurrence`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: fleetEventOccurrenceDateInput, signal
    },
      );
    }




export const getSkipFleetEventOccurrenceMutationKey = () => ['skipFleetEventOccurrence'] as const;

export const getSkipFleetEventOccurrenceMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof skipFleetEventOccurrence>>, TError,SkipFleetEventOccurrenceMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof skipFleetEventOccurrence>>, TError,SkipFleetEventOccurrenceMutationVariables, TContext> => {

const mutationKey = getSkipFleetEventOccurrenceMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof skipFleetEventOccurrence>>, SkipFleetEventOccurrenceMutationVariables> = (props) => {
          const {fleetSlug,slug,data} = props ?? {};

          return  skipFleetEventOccurrence(fleetSlug,slug,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SkipFleetEventOccurrenceMutationResult = NonNullable<Awaited<ReturnType<typeof skipFleetEventOccurrence>>>
    export type SkipFleetEventOccurrenceMutationBody = FleetEventOccurrenceDateInput
    export type SkipFleetEventOccurrenceMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type SkipFleetEventOccurrenceMutationVariables = {fleetSlug: string;slug: string;data: FleetEventOccurrenceDateInput}

    /**
 * @summary Skip a specific occurrence of a recurring event
 */
export const useSkipFleetEventOccurrence = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof skipFleetEventOccurrence>>, TError,SkipFleetEventOccurrenceMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof skipFleetEventOccurrence>>,
        TError,
        SkipFleetEventOccurrenceMutationVariables,
        TContext
      > => {
      return useMutation(getSkipFleetEventOccurrenceMutationOptions(options), queryClient);
    }
    /**
 * @summary Start Fleet Event
 */
export const startFleetEvent = (
    fleetSlug: MaybeRefOrGetter<string>,
    slug: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
slug = toValue(slug);

      return axiosClient<FleetEventExtended>(
      {url: `/fleets/${fleetSlug}/events/${slug}/start`, method: 'PUT', signal
    },
      );
    }




export const getStartFleetEventMutationKey = () => ['startFleetEvent'] as const;

export const getStartFleetEventMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startFleetEvent>>, TError,StartFleetEventMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof startFleetEvent>>, TError,StartFleetEventMutationVariables, TContext> => {

const mutationKey = getStartFleetEventMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof startFleetEvent>>, StartFleetEventMutationVariables> = (props) => {
          const {fleetSlug,slug} = props ?? {};

          return  startFleetEvent(fleetSlug,slug,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StartFleetEventMutationResult = NonNullable<Awaited<ReturnType<typeof startFleetEvent>>>

    export type StartFleetEventMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type StartFleetEventMutationVariables = {fleetSlug: string;slug: string}

    /**
 * @summary Start Fleet Event
 */
export const useStartFleetEvent = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startFleetEvent>>, TError,StartFleetEventMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof startFleetEvent>>,
        TError,
        StartFleetEventMutationVariables,
        TContext
      > => {
      return useMutation(getStartFleetEventMutationOptions(options), queryClient);
    }
    /**
 * @summary Sync event to Discord
 */
export const syncFleetEventToDiscord = (
    fleetSlug: MaybeRefOrGetter<string>,
    slug: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
slug = toValue(slug);

      return axiosClient<FleetEventExtended>(
      {url: `/fleets/${fleetSlug}/events/${slug}/sync-to-discord`, method: 'POST', signal
    },
      );
    }




export const getSyncFleetEventToDiscordMutationKey = () => ['syncFleetEventToDiscord'] as const;

export const getSyncFleetEventToDiscordMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof syncFleetEventToDiscord>>, TError,SyncFleetEventToDiscordMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof syncFleetEventToDiscord>>, TError,SyncFleetEventToDiscordMutationVariables, TContext> => {

const mutationKey = getSyncFleetEventToDiscordMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof syncFleetEventToDiscord>>, SyncFleetEventToDiscordMutationVariables> = (props) => {
          const {fleetSlug,slug} = props ?? {};

          return  syncFleetEventToDiscord(fleetSlug,slug,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SyncFleetEventToDiscordMutationResult = NonNullable<Awaited<ReturnType<typeof syncFleetEventToDiscord>>>

    export type SyncFleetEventToDiscordMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type SyncFleetEventToDiscordMutationVariables = {fleetSlug: string;slug: string}

    /**
 * @summary Sync event to Discord
 */
export const useSyncFleetEventToDiscord = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof syncFleetEventToDiscord>>, TError,SyncFleetEventToDiscordMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof syncFleetEventToDiscord>>,
        TError,
        SyncFleetEventToDiscordMutationVariables,
        TContext
      > => {
      return useMutation(getSyncFleetEventToDiscordMutationOptions(options), queryClient);
    }
    /**
 * @summary Unarchive Fleet Event
 */
export const unarchiveFleetEvent = (
    fleetSlug: MaybeRefOrGetter<string>,
    slug: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
slug = toValue(slug);

      return axiosClient<FleetEventExtended>(
      {url: `/fleets/${fleetSlug}/events/${slug}/unarchive`, method: 'PUT', signal
    },
      );
    }




export const getUnarchiveFleetEventMutationKey = () => ['unarchiveFleetEvent'] as const;

export const getUnarchiveFleetEventMutationOptions = <TError = ErrorType<StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unarchiveFleetEvent>>, TError,UnarchiveFleetEventMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof unarchiveFleetEvent>>, TError,UnarchiveFleetEventMutationVariables, TContext> => {

const mutationKey = getUnarchiveFleetEventMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof unarchiveFleetEvent>>, UnarchiveFleetEventMutationVariables> = (props) => {
          const {fleetSlug,slug} = props ?? {};

          return  unarchiveFleetEvent(fleetSlug,slug,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UnarchiveFleetEventMutationResult = NonNullable<Awaited<ReturnType<typeof unarchiveFleetEvent>>>

    export type UnarchiveFleetEventMutationError = ErrorType<StandardError>
    export type UnarchiveFleetEventMutationVariables = {fleetSlug: string;slug: string}

    /**
 * @summary Unarchive Fleet Event
 */
export const useUnarchiveFleetEvent = <TError = ErrorType<StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unarchiveFleetEvent>>, TError,UnarchiveFleetEventMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof unarchiveFleetEvent>>,
        TError,
        UnarchiveFleetEventMutationVariables,
        TContext
      > => {
      return useMutation(getUnarchiveFleetEventMutationOptions(options), queryClient);
    }
    /**
 * @summary Unlock Signups
 */
export const unlockFleetEventSignups = (
    fleetSlug: MaybeRefOrGetter<string>,
    slug: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
slug = toValue(slug);

      return axiosClient<FleetEventExtended>(
      {url: `/fleets/${fleetSlug}/events/${slug}/unlock-signups`, method: 'PUT', signal
    },
      );
    }




export const getUnlockFleetEventSignupsMutationKey = () => ['unlockFleetEventSignups'] as const;

export const getUnlockFleetEventSignupsMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unlockFleetEventSignups>>, TError,UnlockFleetEventSignupsMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof unlockFleetEventSignups>>, TError,UnlockFleetEventSignupsMutationVariables, TContext> => {

const mutationKey = getUnlockFleetEventSignupsMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof unlockFleetEventSignups>>, UnlockFleetEventSignupsMutationVariables> = (props) => {
          const {fleetSlug,slug} = props ?? {};

          return  unlockFleetEventSignups(fleetSlug,slug,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UnlockFleetEventSignupsMutationResult = NonNullable<Awaited<ReturnType<typeof unlockFleetEventSignups>>>

    export type UnlockFleetEventSignupsMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type UnlockFleetEventSignupsMutationVariables = {fleetSlug: string;slug: string}

    /**
 * @summary Unlock Signups
 */
export const useUnlockFleetEventSignups = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof unlockFleetEventSignups>>, TError,UnlockFleetEventSignupsMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof unlockFleetEventSignups>>,
        TError,
        UnlockFleetEventSignupsMutationVariables,
        TContext
      > => {
      return useMutation(getUnlockFleetEventSignupsMutationOptions(options), queryClient);
    }
    /**
 * @summary Override fields on a single occurrence
 */
export const updateFleetEventOccurrence = (
    fleetSlug: MaybeRefOrGetter<string | null>,
    slug: MaybeRefOrGetter<string | null>,
    fleetEventOccurrenceUpdateInput: MaybeRefOrGetter<FleetEventOccurrenceUpdateInput>,
 signal?: AbortSignal
) => {
      fleetSlug = toValue(fleetSlug);
slug = toValue(slug);
fleetEventOccurrenceUpdateInput = toValue(fleetEventOccurrenceUpdateInput);

      return axiosClient<FleetEventOccurrenceState>(
      {url: `/fleets/${fleetSlug}/events/${slug}/update-occurrence`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: fleetEventOccurrenceUpdateInput, signal
    },
      );
    }




export const getUpdateFleetEventOccurrenceMutationKey = () => ['updateFleetEventOccurrence'] as const;

export const getUpdateFleetEventOccurrenceMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateFleetEventOccurrence>>, TError,UpdateFleetEventOccurrenceMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateFleetEventOccurrence>>, TError,UpdateFleetEventOccurrenceMutationVariables, TContext> => {

const mutationKey = getUpdateFleetEventOccurrenceMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateFleetEventOccurrence>>, UpdateFleetEventOccurrenceMutationVariables> = (props) => {
          const {fleetSlug,slug,data} = props ?? {};

          return  updateFleetEventOccurrence(fleetSlug,slug,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateFleetEventOccurrenceMutationResult = NonNullable<Awaited<ReturnType<typeof updateFleetEventOccurrence>>>
    export type UpdateFleetEventOccurrenceMutationBody = FleetEventOccurrenceUpdateInput
    export type UpdateFleetEventOccurrenceMutationError = ErrorType<SchemaValidationErrorResponse>
    export type UpdateFleetEventOccurrenceMutationVariables = {fleetSlug: string | null;slug: string | null;data: FleetEventOccurrenceUpdateInput}

    /**
 * @summary Override fields on a single occurrence
 */
export const useUpdateFleetEventOccurrence = <TError = ErrorType<SchemaValidationErrorResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateFleetEventOccurrence>>, TError,UpdateFleetEventOccurrenceMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateFleetEventOccurrence>>,
        TError,
        UpdateFleetEventOccurrenceMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateFleetEventOccurrenceMutationOptions(options), queryClient);
    }
